<div class="mod-header">
    <div class="mod-logo">
        <div class="m-logo m-logo--siemens js-logo js-logo-siemens">
            <a (click)="gotoStartPage()"></a>
        </div>
    </div>

    <div class="mod-navigation mod-navigation--icons">
        <button
            class="m-icon--menu-items m-icon language-selector"
            [attr.aria-label]="'aria.select-language' | translate"
            (click)="openLanguageSelection()"
            (focusout)="onFocusOut($event)"
        >
            <div class="language-icon-label"><span class="material-icons">language</span></div>
            @if (showLanguageSelection()) {
                <div class="language-selection-backdrop" (click)="closeLanguageSelection()"></div>
                <div class="language-dropdown" [class.show-lang-sel]="showLanguageSelection()">
                    <ul>
                        @for (language of languages(); track language) {
                            <li>
                                <button class="lang-item" (click)="changeLanguage(language.abbreviation)">
                                    <i
                                        class="material-icons lang-check-icon"
                                        [style.color]="
                                            currentLanguage().abbreviation === language.abbreviation
                                                ? 'black'
                                                : 'transparent'
                                        "
                                    >
                                        done
                                    </i>
                                    {{ language.label }}
                                </button>
                            </li>
                        }
                    </ul>
                </div>
            }
            <p class="selected-language">
                {{ currentLanguage().abbreviation.toUpperCase() }}
            </p>
        </button>
    </div>
</div>
